module.exports = __webpack_public_path__ + "static/media/6f_website_logo_Platinum_mv.d77a8210.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/6f_website_logo_Platinum_mv.jpg
// module id = 101
// module chunks = 0